import{hasWebBridge}from"./bridge";import{DEVICE_TYPE_SMARTPHONE,DEVICE_TYPE_TABLET}from"../constants/deviceTypes";/**
 * Determines the type of the current device.
 * @returns {string}
 */export var getDeviceType=function getDeviceType(){return hasWebBridge()?DEVICE_TYPE_TABLET:DEVICE_TYPE_SMARTPHONE;};